import api from '@http/api';

export interface ILoteParams {
  id_lote?: number;
  usuarioId?: number;
}

class LoteDoacaoServices {
  public async AbrirLote() {
    return await api
      .post('/api/LoteDoacao/AbrirLote')
      .then(() => {
        return { error: false };
      })
      .catch(() => {
        return { error: true };
      });
  }

  public async FecharLote({ id_lote }: ILoteParams) {
    return await api
      .post('/api/LoteDoacao/FecharLote', id_lote, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(() => {
        return { error: false };
      })
      .catch(() => {
        return { error: true };
      });
  }

  public async GetLotesAbertos() {
    return await api
      .get('/api/LoteDoacao/lotes-abertos-usuario')
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async gerarRelatorio(idLote: number): Promise<{ error: boolean; response?: Blob }> {
    return await api
      .get(`/api/LoteDoacao/LotePdfFechado`, {
        params: { idLote },
        responseType: 'blob',
      })
      .then(response => ({
        error: false,
        response: response.data,
      }))
      .catch(() => ({ error: true }));
  }
}

export default LoteDoacaoServices;
